import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

import { cn } from '@repo/utils'

import styles from './index.css'

export const ANIMATE_FROM = {
  BOTTOM: 'BOTTOM',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  TOP: 'TOP',
}

const ANIMATE_CLASS_SET = {
  ALWAYS: {
    appearActive: styles.enterEnd,
    enterActive: styles.enterEnd,
    enterDone: styles.enterEnd,
    exit: styles.exitStart,
  },
  [ANIMATE_FROM.BOTTOM]: {
    appear: styles.fromBottomEnterStart,
    enter: styles.fromBottomEnterStart,
    exitActive: styles.fromBottomExitEnd,
    exitDone: styles.fromBottomExitEnd,
  },
  [ANIMATE_FROM.LEFT]: {
    appear: styles.fromLeftEnterStart,
    enter: styles.fromLeftEnterStart,
    exitActive: styles.fromLeftExitEnd,
    exitDone: styles.fromLeftExitEnd,
  },
  [ANIMATE_FROM.RIGHT]: {
    appear: styles.fromRightEnterStart,
    enter: styles.fromRightEnterStart,
    exitActive: styles.fromRightExitEnd,
    exitDone: styles.fromRightExitEnd,
  },
  [ANIMATE_FROM.TOP]: {
    appear: styles.fromTopEnterStart,
    enter: styles.fromTopEnterStart,
    exitActive: styles.fromTopExitEnd,
    exitDone: styles.fromTopExitEnd,
  },
}

// should be the same value as in 'index.css::$transitionTime'
const TRANSITION_TIME = 1000

class AnimatedList extends PureComponent {
  render() {
    const { animateFrom, children, className, initialDelay, unmountOnExit } = this.props

    return (
      <TransitionGroup className={cn(styles.wrapper, className)}>
        {children.map((child, ind) => (
          <CSSTransition
            key={child.key || ind}
            appear
            classNames={{ ...ANIMATE_CLASS_SET.ALWAYS, ...ANIMATE_CLASS_SET[animateFrom] }}
            enter
            exit
            in
            timeout={{
              appear: initialDelay,
              enter: initialDelay,
              exit: TRANSITION_TIME,
            }}
            unmountOnExit={unmountOnExit}
          >
            {child}
          </CSSTransition>
        ))}
      </TransitionGroup>
    )
  }
}

AnimatedList.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,

  animateFrom: PropTypes.oneOf(Object.keys(ANIMATE_FROM)),
  className: PropTypes.string,
  initialDelay: PropTypes.number,
  unmountOnExit: PropTypes.bool,
}

AnimatedList.defaultProps = {
  animateFrom: ANIMATE_FROM.LEFT,
  className: '',
  initialDelay: 0,
  unmountOnExit: true,
}

export default AnimatedList
